'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useAdUserId } from '@/hooks/useAdUserId';
import { useVerificationCheck } from '@/hooks/useVerificationCheck';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useAdGuards } from './useAdGuards';
import { useOpenAdpopcornOfferwall } from './useOpenAdpopcornOfferwall';
export type AdpopcornStatus = 'unsupported' | 'app-install' | 'login' | 'ready';
interface UseAdpopcornStatusReturn {
  status: AdpopcornStatus;
  isExternalWebview: boolean;
}
interface UseAdpopcornReturn {
  status: AdpopcornStatus;
  isExternalWebview: boolean;
  onClick: () => void;
  isOpening: boolean;
}
export const useAdpopcornStatus = () => {
  const $ = _c(3);
  const {
    isMounted,
    isWelloApp,
    isExternalWebview
  } = useAdGuards();
  const memberOAuth = useAuthStore(_temp);
  let t0;
  bb0: {
    if (!isMounted || isExternalWebview) {
      t0 = "unsupported";
      break bb0;
    }
    if (!isWelloApp) {
      t0 = "app-install";
      break bb0;
    }
    if (!memberOAuth) {
      t0 = "login";
      break bb0;
    }
    t0 = "ready";
  }
  const status = t0;
  let t1;
  if ($[0] !== isExternalWebview || $[1] !== status) {
    t1 = {
      status,
      isExternalWebview
    };
    $[0] = isExternalWebview;
    $[1] = status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useAdpopcorn = () => {
  const $ = _c(18);
  const {
    status,
    isExternalWebview
  } = useAdpopcornStatus();
  const {
    adUserId,
    isPending: isAdUserIdPending
  } = useAdUserId();
  const {
    toast
  } = useToast();
  const t0 = status === "ready";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    checkVerification,
    redirectToVerification,
    isLoading: isVerificationLoading
  } = useVerificationCheck(t1);
  const setIsShowAppInstallConfirmModal = useGlobalStore(_temp2);
  const setIsShowLoginRedirectionConfirmModal = useGlobalStore(_temp3);
  const {
    open,
    isOpening
  } = useOpenAdpopcornOfferwall();
  let t2;
  if ($[2] !== adUserId || $[3] !== checkVerification || $[4] !== isAdUserIdPending || $[5] !== isVerificationLoading || $[6] !== open || $[7] !== redirectToVerification || $[8] !== setIsShowAppInstallConfirmModal || $[9] !== setIsShowLoginRedirectionConfirmModal || $[10] !== status || $[11] !== toast) {
    t2 = () => {
      if (status === "app-install") {
        setIsShowAppInstallConfirmModal(true);
        return;
      }
      if (status === "login") {
        setIsShowLoginRedirectionConfirmModal(true);
        return;
      }
      if (status === "ready") {
        if (isVerificationLoading || isAdUserIdPending) {
          toast({
            message: "\uD68C\uC6D0 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uACE0 \uC788\uC5B4\uC694. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uB20C\uB7EC \uC8FC\uC138\uC694",
            type: "info"
          });
          return;
        }
        if (checkVerification()) {
          return;
        }
        if (!adUserId) {
          redirectToVerification();
          return;
        }
        open(adUserId);
      }
    };
    $[2] = adUserId;
    $[3] = checkVerification;
    $[4] = isAdUserIdPending;
    $[5] = isVerificationLoading;
    $[6] = open;
    $[7] = redirectToVerification;
    $[8] = setIsShowAppInstallConfirmModal;
    $[9] = setIsShowLoginRedirectionConfirmModal;
    $[10] = status;
    $[11] = toast;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const onClick = t2;
  let t3;
  if ($[13] !== isExternalWebview || $[14] !== isOpening || $[15] !== onClick || $[16] !== status) {
    t3 = {
      status,
      isExternalWebview,
      onClick,
      isOpening
    };
    $[13] = isExternalWebview;
    $[14] = isOpening;
    $[15] = onClick;
    $[16] = status;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
function _temp(state) {
  return state.myInfo?.memberOAuth;
}
function _temp2(state) {
  return state.setIsShowAppInstallConfirmModal;
}
function _temp3(state_0) {
  return state_0.setIsShowLoginRedirectionConfirmModal;
}